import { render } from "./DashboardOverview.vue?vue&type=template&id=08836c9b"
import script from "./DashboardOverview.vue?vue&type=script&lang=js"
export * from "./DashboardOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__